var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TerminalPayOptionContext, TerminalPayOptionComponent, useTerminalPayOptionData, } from '@kareo/billing-system';
import React, { useContext } from 'react';
import CardDetailsContext from './CardDetailsContext';
var TerminalPayOptionBridge = function () {
    var terminalPayData = useTerminalPayOptionData();
    var _a = useContext(CardDetailsContext), selectedTerminal = _a.selectedTerminal, setSelectedTerminal = _a.setSelectedTerminal, isUsingTerminalPayOption = _a.isUsingTerminalPayOption, setIsUsingTerminalPayOption = _a.setIsUsingTerminalPayOption;
    var providerValue = __assign(__assign({}, terminalPayData), { isActive: isUsingTerminalPayOption, setIsActive: setIsUsingTerminalPayOption, selectedTerminal: selectedTerminal,
        setSelectedTerminal: setSelectedTerminal, 
        // todo: https://kareodev.atlassian.net/browse/PAY-3956
        setError: function () { } });
    return (React.createElement(TerminalPayOptionContext.Provider, { value: providerValue },
        React.createElement(TerminalPayOptionComponent, null)));
};
export default TerminalPayOptionBridge;
